import * as userRequest from "@/utils/userRequest";

interface DepositSubPaymentPayload {
    amount: number;
    currency: string;
    paymentMethod?: string;
    paymentGateway?: string;
}

export default async function getEstFeeWithSubPayment(
    params: DepositSubPaymentPayload,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get(`/sub-payment-gw/calculate-subpayment-fee`, {
            params,
        });
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }

        throw Error("Something went wrong");
    } catch (err) {
        console.error("🚀 ~ getEstFeeWithSubPayment ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
